const generateBackgroundPosition = content => ({
  backgroundPosition: `${content?.horizontal_focus || '50'}% ${
    content?.vertical_focus || '50'
  }%`,
  horizontalFocus: `${content?.horizontal_focus || 50}%`,
  verticalFocus: `${content?.vertical_focus || 50}%`,
})

export default generateBackgroundPosition
